import { Gpu } from '@typings';
import { isObject } from '@utils/typeof';

/**
 * Defines type guard for GPU new specification
 */
export const isGpuSpec = (spec: unknown): spec is Gpu.Spec => {
  return spec !== null && spec !== undefined && isObject(spec);
};
